import Header from "../Common/Header/Header/Header";
import DashBoardSideBar from "../Common/DashBoardSideBar/DashBoardSideBar";

export default function Layout(props){
    return <>
        <Header />
		<DashBoardSideBar />
        {props?.children}
    </>
}